import Vue from "vue";
import Router from "vue-router";
import fb from "@/main";
import store from "@/state/store";

// General / Foreman
import Home from "./views/Home.vue";
import ToolsOnSite from "./views/ToolsOnSite.vue";
import ToolSearch from "./views/ToolSearch.vue";
import ToolCart from "./views/ToolCart.vue";

// Tool Orders
import MyToolOrders from "./views/MyToolOrders.vue";
import MyToolOrder from "./views/MyToolOrder.vue";
import ToolOrders from "./views/manage/ToolOrders.vue";
import ToolOrder from "./views/manage/ToolOrder.vue";
import ToolRun from "./views/manage/ToolRun.vue";
import PrintForPacking from "./views/manage/PrintForPacking.vue";
import LateToolOrders from "./views/manage/LateToolOrders.vue";

// tool pickups
import MyToolPickups from "./views/MyToolPickups.vue";
import MyToolPickup from "./views/MyToolPickup.vue";
import ToolPickups from "./views/manage/ToolPickups.vue";
import ToolPickup from "./views/manage/ToolPickup.vue";
import ToolPickupRequest from "./views/ToolPickupRequest.vue";

// Yard Management
import ToolList from "./views/manage/ToolList.vue";
import OrderTrucks from "./views/OrderTrucks.vue";
import FindTool from "./views/FindTool.vue";

// tool rentals
import ToolRentals from "./views/manage/ToolRentals.vue";

// work orders
import MyWorkOrders from "./views/MyWorkOrders.vue";
import WorkOrder from "./views/WorkOrder.vue";
import NewWorkOrder from "./views/NewWorkOrder.vue";
import WorkOrders from "./views/pm/WorkOrders.vue";
import WorkOrderPackage from "./views/pm/WorkOrderPackage.vue";

// Truck Requests
import LateOrders from "./views/manage/LateOrders.vue";
import MyTruckRequests from "./views/MyTruckRequests.vue";
import NewTruckRequest from "./views/NewTruckRequest.vue";
import TruckRequests from "./views/manage/TruckRequests.vue";
import TruckRequestsV2 from "./views/manage/TruckRequestsV2.vue";
import Driver from "./views/manage/Driver.vue";
import Trucks from "./views/manage/Trucks.vue";
import TruckSchedule from "./views/TruckSchedule.vue";
import TruckRequest from "./views/manage/TruckRequest.vue";
import TruckRequestReports from "./views/manage/TruckRequestReports.vue";
import MiniContainers from "./views/manage/MiniContainers.vue";
import NewDumpTickets from "./views/manage/NewDumpTickets.vue";

// Truck Service
import MyTruckServiceRequests from "./views/MyTruckServiceRequests.vue";
import TruckServiceRequests from "./views/manage/TruckServiceRequests.vue";
import NewTruckService from "./views/NewTruckService.vue";

// Truck Service
import MyDailyReports from "./views/MyDailyReports.vue";
import DailyReport from "./views/DailyReport.vue";
import DailyReportSummary from "./views/DailyReportSummary.vue";
import DailyReportsList from "./views/DailyReportsList.vue";
import AssignForeman from "./views/AssignForeman.vue";

// Admin/Office
import Users from "./views/Users.vue";
import Jobs from "./views/Jobs.vue";
import Job from "./views/Job.vue";
import JobCost from "./views/JobCost.vue";
import NewJob from "./views/NewJob.vue";
import JobOrders from "./views/JobOrders.vue";
import jobPickups from "./views/JobPickups.vue";
import JobGallery from "./views/JobGallery.vue";
import AdminSignInSheets from "./views/manage/AdminSignInSheets.vue";
import DOBProjects from "./views/manage/DOBProjects.vue";
import Reports from "./views/Reports.vue";
import WeeklySummary from "./views/WeeklySummary.vue";

// Registration / Profile
import Login from "./views/Login.vue";
import Signup from "./views/Signup.vue";
import AwaitingAccess from "./views/AwaitingAccess.vue";
import Profile from "./views/Profile.vue";

// Payroll
import PunchInOut from "./views/PunchInOut.vue";
import PunchDashboard from "./views/PunchDashboard.vue";
import Payroll from "./views/Payroll.vue";
import Employees from "./views/Employees.vue";
import EmployeeSchedule from "./views/EmployeeSchedule.vue";
import EmployeeScheduleCrews from "./views/EmployeeScheduleCrews.vue";
import EmployeeApp from "./views/EmployeeApp.vue";

import AppSupport from "./views/AppSupport.vue";
import AppSupportAdmin from "./views/manage/AppSupportAdmin.vue";
import NewAppSupport from "./views/NewAppSupport.vue";

import MissingDocuments from "./views/manage/MissingDocuments.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup,
      meta: { requiresAuth: false },
    },
    {
      path: "/tools/order",
      name: "toolSearch",
      component: ToolSearch,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/orders",
      name: "my-tool-orders",
      component: MyToolOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/pickups/:orderNumber",
      name: "tool-pickup",
      component: MyToolPickup,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/pickups",
      name: "my-tool-pickups",
      component: MyToolPickups,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/tools-on-site",
      name: "tools-on-site",
      component: ToolsOnSite,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/pickup-request",
      name: "toolpickup",
      component: ToolPickupRequest,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/orders",
      name: "tool-orders",
      component: ToolOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/tool-run",
      name: "tool-run",
      component: ToolRun,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/orders/:orderNumber",
      name: "tool-order",
      component: ToolOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/late-orders",
      name: "late-tool-orders",
      component: LateToolOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/orders/:orderNumber",
      name: "my-tool-order",
      component: MyToolOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/list",
      name: "manage-tools",
      component: ToolList,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/pickups",
      name: "manage-pickups",
      component: ToolPickups,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/pickups/:orderNumber",
      name: "manage-pickup",
      component: ToolPickup,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/print-for-packing/:orderNumber",
      name: "print-for-packing",
      component: PrintForPacking,
      meta: { requiresAuth: true },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (store.state.user.isAdmin) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/jobs",
      name: "jobs",
      component: Jobs,
      meta: { requiresAuth: true },
    },
    {
      path: "/jobs/edit/:id",
      name: "job",
      component: Job,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          store.state.user.permissionGroups &&
          store.state.user.permissionGroups.includes('manageJobSites')
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/jobs/cost/:id",
      name: "job-cost",
      component: JobCost,
      meta: { requiresAuth: true },
    },
    {
      path: "/jobs/new",
      name: "Newjob",
      component: NewJob,
      meta: { requiresAuth: true },
    },
    {
      path: "/jobs/orders/:id",
      name: "job-orders",
      component: JobOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/jobs/pickups/:id",
      name: "job-pickups",
      component: jobPickups,
      meta: { requiresAuth: true },
    },
    {
      path: "/jobs/gallery/:id",
      name: "job-gallery",
      component: JobGallery,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/find-tool/:toolId",
      name: "find-tool",
      component: FindTool,
      meta: { requiresAuth: true },
    },
    {
      path: "/tools/manage/tool-rentals",
      name: "tool-rentals",
      component: ToolRentals,
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/sign-in-sheets",
      name: "admin-sign-in-sheets",
      component: AdminSignInSheets,
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/dob-projects",
      name: "dob-projects",
      component: DOBProjects,
      meta: { requiresAuth: true },
    },
    {
      path: "/weekly-summary",
      name: "weekly-summary",
      component: WeeklySummary,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          ["Office", "Project Manager"].includes(store.state.user.role) ||
          store.state.user.isAdmin
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          ["Office", "Truck Manager"].includes(store.state.user.role) ||
          store.state.user.isAdmin ||
          (store.state.user.permissionGroups &&
            store.state.user.permissionGroups.includes("reports"))
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/awaiting-access",
      name: "awaitingAcess",
      component: AwaitingAccess,
      meta: { requiresAuth: false },
    },
    {
      path: "/tools/cart",
      name: "cart",
      component: ToolCart,
      meta: { requiresAuth: true },
    },
    {
      path: "/work-orders/orders",
      name: "my-work-orders",
      component: MyWorkOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/work-orders/orders/:orderNumber",
      name: "work-order",
      component: WorkOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/work-orders/manage/packages/:id",
      name: "work-order-package",
      component: WorkOrderPackage,
      meta: { requiresAuth: true },
    },
    {
      path: "/work-orders/new",
      name: "new-work-order",
      component: NewWorkOrder,
      meta: { requiresAuth: true },
    },
    {
      path: "/work-orders/manage/orders",
      name: "work-orders",
      component: WorkOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/orders",
      name: "my-truck-requests",
      component: MyTruckRequests,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/trucks",
      name: "trucks",
      component: Trucks,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/schedule",
      name: "truck-schedule",
      component: TruckSchedule,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/new",
      name: "new-truck-request",
      component: NewTruckRequest,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/edit/:id",
      name: "edit-truck-request",
      component: NewTruckRequest,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/late-orders",
      name: "late-truck-requests",
      component: LateOrders,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/orders",
      name: "truck-requests",
      component: TruckRequests,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/scheduler-v2",
      name: "truck-requests-v2",
      component: TruckRequestsV2,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/orders/:id",
      name: "truck-request-close",
      component: TruckRequest,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/driver",
      name: "driver",
      component: Driver,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/mini-containers",
      name: "mini-containers",
      component: MiniContainers,
      meta: { requiresAuth: true },
    },
    {
      path: "/manage/missing-documents",
      name: "missing-documents",
      component: MissingDocuments,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/dump-tickets/new",
      name: "dump-tickets",
      component: NewDumpTickets,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/dump-report",
      name: "dump-reports",
      component: TruckRequestReports,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/manage/service",
      name: "truck-service-requests",
      component: TruckServiceRequests,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/service",
      name: "my-truck-service-requests",
      component: MyTruckServiceRequests,
      meta: { requiresAuth: true },
    },
    {
      path: "/truck-requests/service/new",
      name: "truck-service-requests-new",
      component: NewTruckService,
      meta: { requiresAuth: true },
    },
    {
      path: "/daily-reports",
      name: "my-daily-reports",
      component: MyDailyReports,
      meta: { requiresAuth: true },
    },
    {
      path: "/assign-foreman",
      name: "assign-foreman",
      component: AssignForeman,
      meta: { requiresAuth: true },
    },
    {
      path: "/daily-reports/:jobSiteId/:date/summary",
      name: "daily-report-summary",
      component: DailyReportSummary,
      meta: { requiresAuth: true },
    },
    {
      path: "/daily-reports/:jobSiteId/:date",
      name: "daily-report",
      component: DailyReport,
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/daily-reports",
      name: "daily-reports-list",
      component: DailyReportsList,
      meta: { requiresAuth: true },
    },
    {
      path: "/punch-in-out/:jobSite",
      name: "punch-in-out",
      component: PunchInOut,
      beforeEnter: (to, from, next) => {
        // allow richie and sanchez to use punch in/out and not other yard managers
        if (
          ["richie.fenner@albademo.com", "j.sanchez@albademo.com"].includes(
            store.state.user.email
          )
        ) {
          next();
        } else if (store.state.user.role === "Yard Manager") {
          next("/");
        } else {
          next();
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employee-schedule",
      name: "employee-schedule",
      component: EmployeeSchedule,
      beforeEnter: (to, from, next) => {
        const email = store.state.user.email.toLowerCase();
        if (
          [
            "mikeperugini@albademo.com",
            "robert@volkindustrial.com",
            "mick@albademo.com",
            "richie.fenner@albademo.com",
            "jarina@albademo.com",
            "david@albademo.com",
            "payroll@albademo.com",
            "maylin@albademo.com",
            "erik.torres1@gmail.com",
            "luan@albademo.com",
            "chris@8fiftydigital.com",
            "carlos.torres@albademo.com",
          ].includes(email)
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employee-schedule/crews",
      name: "employee-schedule-crews",
      component: EmployeeScheduleCrews,
      beforeEnter: (to, from, next) => {
        // lowercase email
        const email = store.state.user.email.toLowerCase();
        if (
          [
            "mikeperugini@albademo.com",
            "robert@volkindustrial.com",
            "mick@albademo.com",
            "richie.fenner@albademo.com",
            "jarina@albademo.com",
            "david@albademo.com",
            "payroll@albademo.com",
            "maylin@albademo.com",
            "carlos.torres@albademo.com",
            "luan@albademo.com",
            "erik.torres1@gmail.com",
            "chris@8fiftydigital.com",
          ].includes(email)
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/app-support",
      name: "app-support",
      component: AppSupport,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          store.state.user.permissionGroups &&
          store.state.user.permissionGroups.includes('appSupport')
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/admin/app-support",
      name: "app-support-admin",
      component: AppSupportAdmin,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          store.state.user.permissionGroups &&
          store.state.user.permissionGroups.includes('appSupportAdmin')
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/app-support/new",
      name: "new-app-support",
      component: NewAppSupport,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (
          store.state.user.permissionGroups &&
          store.state.user.permissionGroups.includes('appSupport')
        ) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/punch-dashboard",
      name: "punch-dashboard",
      component: PunchDashboard,
      meta: { requiresAuth: true },
    },
    {
      path: "/payroll",
      name: "payroll",
      component: Payroll,
      beforeEnter: (to, from, next) => {
        if (
          ["Office", "Equipment Manager"].includes(store.state.user.role) ||
          store.state.user.isAdmin
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employee-app",
      name: "employee-app",
      component: EmployeeApp,
      beforeEnter: (to, from, next) => {
        if (
          ["Office", "Equipment Manager"].includes(store.state.user.role) ||
          store.state.user.isAdmin
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employee-app/:requestId",
      name: "employee-app-request",
      component: EmployeeApp,
      beforeEnter: (to, from, next) => {
        if (
          ["Office", "Equipment Manager"].includes(store.state.user.role) ||
          store.state.user.isAdmin
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employees",
      name: "employees",
      component: Employees,
      beforeEnter: (to, from, next) => {
        if (
          [
            "chris@8fiftydigital.com",
            "jarina@albademo.com",
            "david@albademo.com",
            "payroll@albademo.com",
            "crissy@albademo.com",
            "erik.torres1@gmail.com",
          ].includes(store.state.user.email)
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/employees/:id",
      name: "employee-detail",
      component: () => import("./views/EmployeeDetail.vue"),
      beforeEnter: (to, from, next) => {
        if (
          [
            "chris@8fiftydigital.com",
            "jarina@albademo.com",
            "david@albademo.com",
            "payroll@albademo.com",
            "crissy@albademo.com",
            "erik.torres1@gmail.com",
          ].includes(store.state.user.email)
        ) {
          next();
        } else {
          next("/");
        }
      },
      meta: { requiresAuth: true },
    },
    {
      path: "/clients",
      name: "clients",
      component: () => import('./views/Clients.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      // Monthly update for the business. Shared by link only, never in the nav.
      path: "/updates/:updateId",
      name: "app-update",
      component: () => import("./views/AppUpdate.vue"),
      meta: { requiresAuth: true, hideChrome: true },
    },
    {
      path: "/portal/employee/:badgeId",
      beforeEnter: (to) => {
        // Redirect to employee app
        window.location.href = `https://employee.volkindustrial.com/badge/${to.params.badgeId}`;
      },
      meta: { requiresAuth: false },
    },
    {
      path: "*",
      component: OrderTrucks,
      meta: { requiresAuth: true },
    },
  ],
});
router.beforeEach(async (to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if NO logged userd
    if (!fb.auth.currentUser) {
      // Go to login, then back here once signed in
      next({
        path: "/login",
        query: to.fullPath === "/" ? {} : { redirect: to.fullPath },
      });
    } else {
      // Proceed to route
      const token = await fb.auth.currentUser.getIdTokenResult();
      if (!token.claims.access) {
        next({
          path: "/awaiting-access",
        });
      } else if (store.getters["user"]) {
        // don't need o fetch user, already cached
        next();
      } else {
        const { uid } = await fb.auth.currentUser;
        const doc = await fb.db
          .collection("users")
          .doc(uid)
          .get();
        store.commit("cacheUser", doc.data());
        next();
      }
    }
  } else {
    // catch possible refresh on awaiting access and get user
    if (to.path == "/awaiting-access") {
      const { uid } = await fb.auth.currentUser;
      const doc = await fb.db
        .collection("users")
        .doc(uid)
        .get();
      store.commit("cacheUser", doc.data());
    }
    // Proceed to route
    next();
  }
});
export default router;
